import { render, staticRenderFns } from "./VButtonMinus.vue?vue&type=template&id=0d21f57a&"
import script from "./VButtonMinus.vue?vue&type=script&lang=js&"
export * from "./VButtonMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports